export default __webpack_public_path__ + "assets/images/pause-w.a0a162175b6a5590406449cd1a72bfd6.svg";